import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Project } from '../../../../../../../../../shared/models';
import { CommonService } from '../../../../../../../../../shared/services/common.service';
import * as fromRoot from '../../../../../../../../../state/app.state';
import {
  CreateProjectMaterialTestRequest,
  UpdateProjectMaterialTestRequest,
} from '../../../../../../../core/projects.actions';

@Component({
    selector: 'app-material-test-create-edit-popup',
    templateUrl: './material-test-create-edit-popup.component.html',
    styleUrls: ['./material-test-create-edit-popup.component.scss'],
    standalone: false
})
export class MaterialTestCreateEditPopupComponent implements OnInit {
  public project!: Project;
  public item!: any;
  public form!: FormGroup<any>;
  public errorMessages: Record<string, string> = {};
  public errorMessageMap: Record<string, Record<string, string>> = {
    name: {
      required: 'This field is required.',
    },
  };

  constructor(
    private commonService: CommonService,
    private store: Store<fromRoot.State>,
    public dialogRef: MatDialogRef<MaterialTestCreateEditPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { project: Project; item?: any }
  ) {
    this.project = data.project;
    this.item = data.item;

    this.form = new FormGroup<any>({
      name: new FormControl({ value: this.item?.name || this.item?.value || '', disabled: false }, [
        Validators.required,
      ]),
    });
  }

  ngOnInit(): void {}

  checkForErrors(currentField?: string): void {
    this.errorMessages = {
      ...this.errorMessages,
      ...this.commonService.checkFormValidation(this.form, this.errorMessageMap, currentField),
    };
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    if (!this.form.valid || !this.project?.id) {
      this.checkForErrors();
      return;
    }
    const name = this.form.get('name')?.value?.trim();
    if (!name) return;

    const testId = this.item?.id ?? this.item?.testId;
    if (!this.item || !testId) {
      this.store.dispatch(
        CreateProjectMaterialTestRequest({
          projectId: this.project.id,
          name,
        })
      );
    } else {
      this.store.dispatch(
        UpdateProjectMaterialTestRequest({
          projectId: this.project.id,
          testId: String(testId),
          name,
        })
      );
    }
  }
}
